import { render, staticRenderFns } from "./NewBeforeFacture.vue?vue&type=template&id=6a4c07c4&"
import script from "./NewBeforeFacture.vue?vue&type=script&lang=ts&"
export * from "./NewBeforeFacture.vue?vue&type=script&lang=ts&"
import style0 from "./NewBeforeFacture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports